import Vue from 'vue'
import App from './App.vue'
import router from "./router"

import store from './store';

import 'view-design/dist/styles/iview.css';
import iView from "view-design";
Vue.use(iView);

Vue.config.productionTip = false

const addComma = (num = 0, str = ',') => {
    if (num || num == 0) {
        return num.toString().replace(/\d+/, function (n) {
            return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + str)
        })
    }
}

Vue.prototype.$addComma = addComma;

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app')
